import { GetZoneMapConfigInput, useGetZoneMapConfigQuery } from '@graphql/generated/graphql';

const useGetZoneMapConfig = (input: GetZoneMapConfigInput) => {
  const {
    data,
    error: queryError,
    isError,
    isLoading,
  } = useGetZoneMapConfigQuery(
    {
      input,
    },
    {
      refetchOnWindowFocus: false,
    },
  );

  const graphqlError = data?.getZoneMapConfig?.error;
  const error = graphqlError || queryError;
  const hasError = isError || !!graphqlError;
  const zoneMapConfig = data?.getZoneMapConfig.zoneMapConfig;

  return {
    zoneMapConfig,
    error,
    hasError,
    isLoading,
    errorMessage: graphqlError?.errorMessage || (queryError as Error)?.message,
    errorType: graphqlError?.errorType,
  };
};

export default useGetZoneMapConfig;
